import _objectWithoutProperties from "/opt/bread/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["capacity"];
export var filterCustomerCloseDataCapacity = function filterCustomerCloseDataCapacity(customerCloseData, canViewCapacity) {
  var capacity = customerCloseData.capacity,
      filteredCustomerCloseData = _objectWithoutProperties(customerCloseData, _excluded);

  return canViewCapacity ? customerCloseData : filteredCustomerCloseData;
};